import { render, staticRenderFns } from "./reportAccess.vue?vue&type=template&id=61943bf5&scoped=true"
import script from "./reportAccess.vue?vue&type=script&lang=js"
export * from "./reportAccess.vue?vue&type=script&lang=js"
import style0 from "./reportAccess.vue?vue&type=style&index=0&id=61943bf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61943bf5",
  null
  
)

export default component.exports